document.addEventListener("DOMContentLoaded", () => {
    // Set a timeout to delay execution after the DOM is loaded
    setTimeout(() => {
      // Function to handle adding autoplay
      const handleAutoplay = () => {
        const parent = document.querySelector(".slick-current.slick-active.slick-center");
        if (parent) {
          const video = parent.querySelector("video");
          if (video) {
            video.setAttribute("autoplay", "true");
            video.setAttribute("controls", "true");
            console.log("Autoplay added and video playback started.");
            video.play();
          }
        }
      };
  
      // Function to remove autoplay from all non-active slides
      const removeAutoplay = () => {
        const videos = document.querySelectorAll(".slick-slide video");
        videos.forEach(video => {
          video.removeAttribute("autoplay");
          video.removeAttribute("controls");
          video.pause(); // Pause video if it was playing
          console.log("Autoplay removed and video playback stopped.");
        });
      };
  
      // Function to update autoplay on slide change
      const updateAutoplay = () => {
        removeAutoplay();
        handleAutoplay();
      };
  
      // Run on page load
      updateAutoplay();
  
      // Use event delegation for arrow clicks
      const slickContainer = document.querySelector(".slick-slider"); // Adjust this selector to match your carousel container
      if (slickContainer) {
        slickContainer.addEventListener("click", (event) => {
          if (event.target.classList.contains("slick-arrow")) {
            setTimeout(updateAutoplay, 100); // Slight delay for slide transition
          }
        });
      }
  
      // Listen to the Slick carousel's `afterChange` event
      $('.slick-slider').on('afterChange', () => {
        updateAutoplay();
      });
  
    }, 1000); // Delay execution by 1 second
  });
  